import gql from 'graphql-tag';
import { apolloClient as apollo } from '@/vue-apollo';

/**
 * @param {String|Number} supplierAttributeId
 * @param {Object} updatedSupplierAttribute
 */
export const addUpdateSupplierAttribute = async (updatedSupplierAttribute = {}, supplierAttributeId = 0) => {
	try {
		const mutation = gql`
			mutation ($supplierAttributeId: ID!, $updatedSupplierAttribute: SupplierAttributeInput!) {
				AddUpdSupplierAttribute(SupplierAttributeId: $supplierAttributeId, UpdatedSupplierAttribute: $updatedSupplierAttribute) {
					id
					name
					description
					webSite
					xidLogo
				}
			}
		`;
		const {
			data: { AddUpdSupplierAttribute }
		} = await apollo.mutate({
			mutation,
			variables: {
				supplierAttributeId: parseInt(supplierAttributeId, 10),
				updatedSupplierAttribute
			}
		});

		return AddUpdSupplierAttribute;
	} catch (e) {
		console.error({ e });
	}
};

/**
 * @param {String|Number} supplierAttributeId
 */
export const delSupplierAttribute = async (supplierAttributeId) => {
	try {
		const mutation = gql`
			mutation ($supplierAttributeId: ID!) {
				DelSupplierAttribute(SupplierAttributeId: $supplierAttributeId)
			}
		`;
		const {
			data: { DelSupplierAttribute }
		} = await apollo.mutate({
			mutation,
			variables: {
				supplierAttributeId: parseInt(supplierAttributeId, 10)
			},
			fetchPolicy: 'no-cache'
		});

		return DelSupplierAttribute;
	} catch (e) {
		console.error({ e });
	}
};

/**
 * @param {String|Number} supplierAttributeId
 */
export const getSupplierAttribute = async (supplierAttributeId) => {
	try {
		const {
			data: { GetSupplierAttribute }
		} = await apollo.query({
			query: gql`
				query ($supplierAttributeId: ID!) {
					GetSupplierAttribute(SupplierAttributeId: $supplierAttributeId) {
						id
						name
						description
						webSite
						xidLogo
					}
				}
			`,
			variables: {
				supplierAttributeId: parseInt(supplierAttributeId, 10)
			},
			fetchPolicy: 'no-cache'
		});

		return GetSupplierAttribute;
	} catch (e) {
		console.log({ e });
	}
};

/**
 * @param {Number} supplierAttributesType
 */
export const getSupplierAttributes = async (supplierAttributesType) => {
	try {
		const {
			data: { GetSupplierAttributes }
		} = await apollo.query({
			query: gql`
				query ($supplierAttributesType: ID!) {
					GetSupplierAttributes(SupplierAttributesType: $supplierAttributesType) {
						id
						name
						description
						webSite
						xidLogo
					}
				}
			`,
			variables: {
				supplierAttributesType: parseInt(supplierAttributesType, 10)
			},
			fetchPolicy: 'no-cache'
		});

		return GetSupplierAttributes;
	} catch (e) {
		console.log({ e });
	}
};
